module.exports = __webpack_public_path__ + "static/media/hangman05.fa3a1b0b.svg";